import { withProfiling } from '../self-measurements';
import { resourceTimingBuffer } from './common/utils/resource-timing-buffer';
export var startResourceTimingBuffer = withProfiling(function startResourceTimingBuffer() {
  resourceTimingBuffer.start();
});